import { useEffect, useState } from 'react';

import Image from 'next/image';
import styled from 'styled-components';
import { PAGE_OPTIONS } from '../Trust/Trustbar';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
const Link = dynamic(() => import('next/link'));
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const CalendarPaxModal = dynamic(() => import('../CalendarAndPax/Modal'));
import {
  optimizeImageUrl,
  optimizeVideoUrl
} from '../../utils/videoLinkOptimize';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { toTitleCase } from '../../utils/removeDuplicateCountryName';
SwiperCore.use([Autoplay, Pagination, Navigation]);
interface IProps {
  product: Record<string, any>;
  productType?: string;
  kind?: string;
}
const StyledSwiper = styled(Swiper)`
  // Set the desired styles for the Swiper slider here
  .swiper-pagination-bullet-active {
    background-color: #fd4c5c;
  }
  .swiper-pagination {
    margin-bottom: 15px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    position: absolute;
    top: 50%;
    width: 40px;
    height: 40px;
    margin-top: -15px;
    border-radius: 50%;
    opacity: 0.8;
    z-index: 10;
    background-color: #e04846;
    transition: all 0.3s ease;

    @media (max-width: 700px) {
      width: 35px;
      height: 35px;
    }

    &::after {
      color: white;
      position: absolute;
      width: 10px;
      height: 10px;
      top: 35%;
      left: 50%;
      font-size: 1.5rem;
      transform: translate(-50%, -50%);
      border-style: solid;
      border-color: #fff;
      z-index: 50;
    }

    &.swiper-button-disabled {
      opacity: 0.3;
      cursor: not-allowed;
      background-color: #f15c5a;
    }
  }

  .swiper-button-next {
    right: 5px;

    &:not(.swiper-button-disabled):hover {
      opacity: 1;
      background-color: #e04846;
    }
  }

  .swiper-button-prev {
    left: 5px;

    &:not(.swiper-button-disabled):hover {
      opacity: 1;
      background-color: #e04846;
    }

    &::after {
      left: 40%;
    }
  }
`;
const PriceContainerStyle = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  color: #ffffff;
  text-align: center;
  background-color: #f15c5a;
  border: none;
  z-index: 10;
`;
export const SnippetStyle = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const TourCard = ({ product, productType }: IProps) => {
  const [image, setImage] = useState<any>([]);
  const [openPax, setOpenPax] = useState<boolean>(false);
  //storing Images in array
  useEffect(() => {
    const imageArr: Array<Record<string, any>> = [];
    product?.carousel?.map((img: Record<string, any>, index: number) => {
      imageArr.push({
        key: index + 1,
        imageUrl: img?.url,
        hasVideo: img?.type.public_id.includes('video')
      });
      setImage(imageArr);
    });
  }, [product?.carousel]);
  // REVIEWS AVG
  let totalAvg = 0;
  let total = 0;
  if (product?.reviews) {
    product?.reviews.forEach((review: any) => {
      total += Number(review?.rating);
    });
    totalAvg = Number((total / product?.reviews?.length).toFixed(1));
  }
  return (
    <Link href={`/tours/${product?.slug}`}>
      <div
        id="tour-section"
        className="relative flex flex-col  rounded-[15px] bg-transparent shadow-xl   pb-[50px] h-full"
      >
        {/* {openPax && (
          <CalendarPaxModal
            tour={product.name}
            tourId={product.id}
            tourImage={image[0]?.imageUrl}
            open={openPax}
            setOpenPax={setOpenPax}
            slug={product.slug}
            privateTour={product.private}
            name={product.name}
            rating={totalAvg}
            guest={total}
            cardMessage={product.cardMessage}
          />
        )} */}

        <div className="h-[240px] xsm:h-[280px] sm:h-[300px] md:h-[260px] lg:h-[260px] xl:h-[300px] w-[95%] py-2 mx-auto relative">
          <Link
            href={`/tours/${product?.slug}`}
            className="rounded-md h-[100%]"
          >
            <div className="w-[100%] h-[100%] relative rounded-lg !overflow-hidden">
              {/* {product?.price && (
              <PriceContainerStyle
                id="price_container"
                className="py-1 lg:py-1 px-3 lg:px-5 2xl:px-6  text-base font-[700] rounded-[3px]"
              >
                ${product?.price.toFixed(2)}
              </PriceContainerStyle>
            )} */}

              {product?.cardMessage &&
                (product?.cardMessage === 'AWARD WINNER!' ? (
                  <div className="absolute z-30 max-w-[300px] lg:max-w-[250px] py-2 px-2">
                    <Image
                      src="/award-winner.png"
                      width={100}
                      height={100}
                      quality={100}
                      alt="award-winner-logo"
                      className="w-[50px] h-[56px] xl:w-[70px] xl:h-[76px] "
                      priority={true}
                    />
                  </div>
                ) : (
                  <p
                    className={`absolute max-w-[300px] lg:max-w-[250px] py-1 px-2.5 text-white bg-[#E24141] z-30 font-medium text-sm sm:text-base rounded-tl-[12px] rounded-br-[12px]`}
                  >
                    {product?.cardMessage?.toLowerCase() === 'new tour!'
                      ? 'Likely to sell out'
                      : toTitleCase(product?.cardMessage)}
                  </p>
                ))}
              <StyledSwiper
                slidesPerView={1}
                spaceBetween={1}
                navigation={{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev'
                }}
                // autoplay={{
                //   delay: 4000,
                //   disableOnInteraction: false
                // }}
                pagination={{
                  dynamicBullets: false,
                  clickable: true
                }}
                className="w-[100%] h-[100%]"
                lazy
              >
                {image?.map((img: any, index: number) => (
                  <SwiperSlide key={index} className="w-[100%] h-[100%]">
                    {img?.hasVideo ? (
                      <video
                        src={optimizeVideoUrl(img?.imageUrl)}
                        muted
                        loop
                        playsInline
                        className="w-[100%] h-[100%] object-cover"
                        autoPlay
                      ></video>
                    ) : (
                      <Image
                        src={optimizeImageUrl(img?.imageUrl)}
                        width={350}
                        height={350}
                        alt="feature product image"
                        className="w-[100%] h-[100%] object-cover rounded-lg hover:scale-105 ease-in-out duration-200"
                        placeholder="blur"
                        blurDataURL="/placeholder.webp"
                        loading="lazy"
                      />
                    )}
                  </SwiperSlide>
                ))}
                <div className="swiper-button-next"></div>
                <div className="swiper-button-prev"></div>
              </StyledSwiper>
            </div>
          </Link>

          <div className="absolute top-[94%] w-[100%] mx-auto z-30">
            <div id="rating_container" className="w-[96%] mx-auto">
              <div className="flex justify-between bg-[#E4F6F1] rounded-[5px] py-2 px-2">
                <div id="tour-time">
                  <p className="text-[#000000]  text-base font-[400]">
                    {productType !== PAGE_OPTIONS.MULTIDAY_TOUR_PAGE
                      ? product?.duration && `${product?.duration} Hours`
                      : `${Number(product?.duration) / 24} Days`}
                  </p>
                </div>
                {product?.reviews?.length > 0 && (
                  <div className="flex px-2">
                    <p className="px-1 text-[#FF9921]  text-base font-[500]">{`${totalAvg}/5`}</p>
                    <Image
                      src="/homestar.svg"
                      width={15}
                      height={15}
                      alt="rating star"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="h-[25px] lg:h-[30px] xl:h-[30px]"></div>

        <div id="description" className="flex flex-col w-[95%] mx-auto gap-2">
          <div id="heading">
            <h2 className="text-base lg:text-lg font-semibold mt-2 ">
              {product?.name}
            </h2>
          </div>
          <div id="snippet">
            <SnippetStyle className=" text-sm lg:text-base  text-[#444444] font-[400]">
              {product?.name?.length < 120
                ? product?.cardSnippet?.length < 115
                  ? `${product?.cardSnippet}`
                  : `${product?.cardSnippet
                      ?.split('')
                      ?.slice(0, 97)
                      ?.join('')}...`
                : product?.cardSnippet.length < 120
                ? `${product?.cardSnippet}`
                : `${product?.cardSnippet
                    ?.split('')
                    ?.slice(0, 95)
                    ?.join('')}...`}
            </SnippetStyle>
          </div>
        </div>
        <div
          id="checkout_buttons"
          className="flex justify-between items-center px-3 py-2 w-full absolute bottom-1 "
        >
          <p className="text-[#333333] text-lg lg:text-[24px] font-bold">
            <span className="text-base lg:text-lg font-normal">From </span>
            {`$${product?.price}`}
          </p>
          {/* <button
          className="flex-none w-[37%] py-2 text-[#FFFFFF] text-center font-[500] text-xs sm:text-base xl:text-lg bg-[#F15C5A] rounded-[8px] md:rounded-[10px]"
          onClick={() => {
            setOpenPax(true);
          }}
        >
          <button>Book Now</button>
        </button> */}
        </div>
      </div>
    </Link>
  );
};

export default TourCard;
